import PricingContent from "./pricing-content";

export { PricingContent };
